export interface IHomePageStoreState {
  // ! this can spliced off into separate reducer altogether
  offersApi: IOffersApi;
  homeSeoData: ISeoData;
}

export interface ISeoData {
  h1: string;
  title: string;
}

export interface IOffersApi {
  isLoading: boolean;
  data: Array<ISlug>;
}

export interface ISlug {
  slug: string;
  url: string;
  sub_heading: string;
  validity_text: string;
  img_url: string;
  order: number;
}

export const UPDATE_OFFERS_DATA = 'UPDATE_OFFERS_DATA';
export const TOGGLE_LOADING_GETOFFERS = 'TOGGLE_LOADING_GETOFFERS';

export const UPDATE_HOME_SEO_DATA = 'UPDATE_HOME_SEO_DATA';

export interface IUpdateSEOData {
  type: typeof UPDATE_HOME_SEO_DATA;
  homeSeoData: ISeoData;
}

export interface IUpdateOffersData {
  type: typeof UPDATE_OFFERS_DATA;
  actionData: IOffersApi['data'];
}

export interface IToggleLoadingGetOffersData {
  type: typeof TOGGLE_LOADING_GETOFFERS;
  actionData: IOffersApi['isLoading'];
}

export type HomePageActionTypes = IUpdateOffersData | IToggleLoadingGetOffersData | IUpdateSEOData;
